import HeaderEnum from '../../enumerators/header.enum'

export default class SwitchComponent {
    constructor() {
        SwitchComponent.init()
    }

    static init() {
        $(HeaderEnum.SWITCH).on('click', function (event) {
            if ($(event.target).hasClass('active')) {
                return
            }
            $(this).toggleClass('header__switch--active')
            $(this).find(HeaderEnum.SWITCH_LABEL).toggleClass('active')
            $(this).submit()
        })
    }
}
